module.exports = __webpack_public_path__ + "img/1@2x.d87c5df0.jpg";